import { ref, useAttrs, watch } from 'vue'

export function forwardEvents (emit) {
    const attrs = useAttrs()
    const forwardedEvents = ref({})

    watch(() => attrs, (newAttrs) => {
        const newForwardedEvents = {}

        Object.keys(newAttrs).forEach((key) => {
            if (key.startsWith('on')) {
                const eventName = key.slice(2).toLowerCase()
                newForwardedEvents[eventName] = (...args) => {
                    emit(eventName, ...args)
                }
            }
        })

        forwardedEvents.value = newForwardedEvents
    },
    {
        immediate: true, deep: true
    })

    return forwardedEvents
}
